var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ApolloLink, } from '@apollo/client/core';
import { getMainDefinition, hasDirectives, removeDirectivesFromDocument, } from '@apollo/client/utilities';
import { prefixTypenames, getDirectiveArgumentValueFromOperation, isFunction, } from './utils';
var MultiAPILink = /** @class */ (function (_super) {
    __extends(MultiAPILink, _super);
    function MultiAPILink(config, request) {
        var _this = _super.call(this, request) || this;
        _this.config = config;
        _this.httpLink = config.createHttpLink();
        _this.wsLinks = {};
        return _this;
    }
    MultiAPILink.prototype.request = function (operation, forward) {
        var _a, _b, _c;
        if ((!hasDirectives(['api'], operation.query) &&
            !this.config.defaultEndpoint) ||
            hasDirectives(['rest'], operation.query)) {
            return (_a = forward === null || forward === void 0 ? void 0 : forward(operation)) !== null && _a !== void 0 ? _a : null;
        }
        var apiName = getDirectiveArgumentValueFromOperation(operation, 'api', 'name');
        if (!apiName) {
            var contextKey = getDirectiveArgumentValueFromOperation(operation, 'api', 'contextKey');
            if (contextKey) {
                apiName = operation.getContext()[contextKey];
            }
            else if (!!this.config.defaultEndpoint) {
                apiName = this.config.defaultEndpoint;
            }
        }
        var query = removeDirectivesFromDocument([{ name: 'api', remove: true }], operation.query);
        if (!query) {
            throw new Error('Error while removing directive api');
        }
        operation.query = query;
        if (this.config.getContext) {
            operation.setContext(this.config.getContext(apiName, operation.getContext));
        }
        if (this.config.endpoints[apiName]) {
            operation.setContext({
                uri: "".concat(this.config.endpoints[apiName]).concat((_b = this.config.httpSuffix) !== null && _b !== void 0 ? _b : '/graphql'),
            });
        }
        else if (process.env.NODE_ENV === 'dev') {
            throw new Error("".concat(apiName, " is not defined in endpoints definitions"));
        }
        var definition = getMainDefinition(operation.query);
        if (definition.kind === 'OperationDefinition' &&
            definition.operation === 'subscription') {
            if (!this.config.createWsLink) {
                throw new Error("You tried to call a subscription without configuring \"createWsLink\" function:".concat(operation.query));
            }
            if (!this.wsLinks[apiName]) {
                var endpoint = this.config.endpoints[apiName];
                var wsEndpoint = endpoint.startsWith('/')
                    ? "".concat(window.location.origin).concat(endpoint).replace('http', 'ws')
                    : endpoint.replace('http', 'ws');
                this.wsLinks[apiName] = this.config.createWsLink("".concat(wsEndpoint).concat((_c = this.config.wsSuffix) !== null && _c !== void 0 ? _c : '/graphql/subscriptions'));
            }
            var response_1 = this.wsLinks[apiName].request(operation, forward);
            if (this.config.prefixTypenames && isFunction(response_1 === null || response_1 === void 0 ? void 0 : response_1.map)) {
                return response_1.map(function (e) { return prefixTypenames(e, apiName); });
            }
            return response_1;
        }
        var response = this.httpLink.request(operation, forward);
        if (this.config.prefixTypenames && isFunction(response === null || response === void 0 ? void 0 : response.map)) {
            return response.map(function (e) { return prefixTypenames(e, apiName); });
        }
        return response;
    };
    return MultiAPILink;
}(ApolloLink));
export { MultiAPILink };
//# sourceMappingURL=MultiAPILink.js.map